<template>
  <div class="promiserules">
    <div :class="['contain',{'containdhjr':fromdhjr}]">
      <div class="titlecontent">
        <div :class="['promiserulestitle',{'titleactive':activeTab=='promise'},{'promiserulestitledhjr':fromdhjr},{'titleactivedhjr':activeTab=='promise'&&fromdhjr}]" @click="activeTab='promise'">参赛承诺书</div>
        <img v-if="!fromdhjr" src="../../assets/btfg.png"/>
        <div :class="['promiserulestitle',{'titleactive':activeTab=='rules'},{'promiserulestitledhjr':fromdhjr},{'titleactivedhjr':activeTab=='rules'&&fromdhjr}]" @click="activeTab='rules'">参赛规则</div>
      </div>
      <div :class="['info',{'dhjr':fromdhjr}]">
        <div v-if="activeTab=='promise'" :class="['promiserulescontent',{'promiserulescontentdhjr':fromdhjr}]">
          <p>本人/本机构（以下简称“本人”）自愿参加东航期货有限责任公司主办的“蓝海密剑 中国私募基金创富榜”（以下简称“本大赛”），并已经充分、仔细地阅读、理解并完全接受本大赛规则以及本确认书内容，在此谨向主办方承诺并确认如下：</p>
          <p>1、本人已阅读、理解并自愿遵守主办方指定官网、媒体上公布的本大赛规则。</p>
          <p>2、本人承诺将严格遵守中国证券法律法规、相关自律规则和交易规则，依法合规地参与本次私募大赛，不触碰相关法律红线，不违反监管条例，不存在非法募集、配资等情形，确保所有交易的合法性。</p>
          <p>3、本人同意主办方有权对大赛规则进行解释、更改、增加或删除；更改或增加的规则将作为大赛规则不可分割的一部分。该更改、增加或删除包括但不限于：暂停或延长大赛日程，变更晋级标准，更改大赛开始、中止、终结日期等。</p>
          <p>4、主办方有权基于不可抗力、情势变更或政府部门的相关规定、通知、命令随时终止大赛，并不得因此向主办方主张任何法律或经济上的权利。
            “不可抗力”是指主办方与参赛选手任何一方无法控制、不可预见或即使可以预见但无法避免的且阻碍该方全部或部分履行本次大赛义务的所有事件。该类事件包括但不限于任何罢工、工厂关闭、爆炸、自然灾害或公敌行为、火灾、洪水、破坏活动、意外事故、战争、暴动、叛乱以及任何其他类似事件。</p>
          <p>5、本人承诺参赛前已经核实并确保参赛金融产品的投资及交易策略、范围等与产品合同保持一致，不存在违法违规以及侵犯任何第三方权益的情况，不存在违反产品合同约定的情况。</p>
          <p>6、本人承诺自负盈亏，所有交易行为须遵守相关法律法规、自律规则并保证不存在内幕交易、利益输送等违法违规的情况。</p>
          <p>
            7、本人本人承诺同意大赛主办方、联合主办方及协办方在合规范围内查看并按赛会需求使用本机构发送至大赛相关平台的产品信息（公司资料、产品资料、产品净值等）进行公开披露或计算。本人承诺按照主办方要求上报比赛数据，按时披露相关信息，保证比赛数据上传的及时性、全面性与真实性。</p>
          <p>8、本人同意大赛结束或本人退赛后，已提供给大赛相关各方的信息及数据，大赛相关各方可以继续保留并使用。</p>
          <p>9、本人承诺将遵守参赛期间接触的相关商业秘密予以保密，未经相关方书面同意，不得泄露给任何第三方，否则，主办方有权追究其法律责任。</p>
          <p>10、本人自愿服从主办方在参赛规则中要求的其他重要事项。</p>
          <p>本人已仔细阅读并理解大赛规则以及本确认书内容，并同意在此签定本电子协议书并受其约束。本确认书自本人签订提交之日起生效。</p>
        </div>
        <div v-if="activeTab=='rules'" :class="['promiserulescontent',{'promiserulescontentdhjr':fromdhjr}]">
          <div :class="['rulestitle',{'rulestitledhjr':fromdhjr}]">蓝海密剑 中国私募基金创富榜</div>
          <div :class="['title',{'titledhjr':fromdhjr}]">一、大赛规则</div>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">1、参赛条件</div>
          <p>大赛面向全市场私募基金机构管理的私募产品，不指定托管人或经纪商。需符合以下条件：</p>
          <p>（1）参赛机构需为中国证券投资基金业协会登记备案的私募基金管理人；参赛产品在参赛前已完成在中国证券投资基金业协会的备案。

          </p>
          <p>（2）同一参赛机构最多可以报名8个产品进行比赛，同一组别下同一机构最多可以报名3个产品进行比赛。
          </p>
          <p>（3）产品规模需在1000万元以上。</p>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">2、比赛时间</div>
          <p>2022年1月1日—2022年12月31日。</p>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">3、报名方式
          </div>
          <p>
            网上Web端活动页面报名
          </p>
          <p>手机移动端H5页面报名
          </p>
          <p>随时可以报名。</p>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">4、参赛须知</div>
          <p>（1）主办方会根据报名情况对拟参赛的机构及产品进行审核，并反馈是否报名成功。</p>
          <p>（2）管理人报名参赛即视为其已承诺将如实填报管理人信息及净值等数据。</p>
          <p>（3）参赛机构应于每周三（节假日顺延）17：00前到大赛指定平台录入上周最后一个交易日的累计单位净值等数据。主办方工作人员将会对净值进行审核，因参赛私募报送错误或报送不及时产生的排名误差，参赛私募自行负责。</p>
          <p>（4）大赛期间收益率为负的产品，不参与年度获奖评选。</p>
          <p>（5）参赛私募自负盈亏，参赛私募需保证报送的数据及时准确全面，参赛私募应签署授权书，授权主办方及联合主办方获取比赛相关数据，并可在官网、微信、微博、APP等其他系统中进行合规宣传或披露。</p>
          <p>（6）2022年1月1日前报名的产品，以2021年12月31日的净值等数据为初始成绩；2022年1月1日起报名的产品，以报名后录入的最早净值等数据为初始成绩。</p>
          <p>（7）每季度后，排行前三名的参赛机构，应主动提交经托管人确认的季度净值数据到大赛指定邮箱（lhmj@kiiik.com），以便大赛组委进行核对。</p>
          <p>（8）参赛产品要求真实有效，且持续净值更新。若经大赛组委核实净值有误，或净值一个月以上未更新，主办方有权取消参赛资格。</p>
          <p>（9）东航金控种子基金，将对部分参赛私募机构产品进行跟投或合作发行产品。投资前，私募机构需与资方进行商务洽谈。</p>
          <p>
            （10）本次比赛为私募机构实盘交易比赛，参赛机构自行交易，所有交易须遵守相关法律法规。主办机构发现或有人举报，经核实认定参赛机构确有舞弊行为或操纵市场等嫌疑的，立即取消参赛机构的参赛资格；由此产生的一切后果由参赛机构承担。</p>
          <p>
            （11）机构参与比赛，则视为同意东航期货、云纪网络获得及使用机构按大赛要求提供的所有数据。当主办方提出查验数据真实性时，参赛机构应当配合提供比赛期间的经托管人盖章的相关数据。如果查验数据发现虚假数据或未配合提供托管人盖章数据，则不参与榜单排名。</p>
          <p>（12）本次比赛排名收益率仅供参考，不构成任何投资建议。</p>
          <p>（13）比赛结束后，主办方将以电话或电子邮件方式通知获奖机构的报名联系人，若无法与获奖机构的联系人取得联系，则视为获奖机构自动放弃获奖权益。
          </p>
          <p>备注：另附录入净值指引 （已提供）</p>

          <div :class="['title',{'titledhjr':fromdhjr}]">二、比赛分组</div>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">参赛策略</div>
          <p>1、股票策略（主要投资于股票市场，且总头寸占比超60%）</p>
          <p>2、对冲策略（同时持有资产相关、规模相当的多空头寸策略，且总头寸占比超60%）</p>
          <p>3、CTA及衍生品策略（主要投资于商品及金融衍生品，且投资比例超60%）</p>
          <p>4、混合策略（采用多种投资策略，且每种策略的投资比例不超过60%）</p>
          <p>5、其他策略（包括固收、日内等其他各种策略）</p>
          <div :class="['title',{'titledhjr':fromdhjr}]">三、评分方法</div>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">1、评比规则</div>
          <p>大赛将按照股票策略、对冲策略、CTA及衍生品策略、混合策略及其他策略共5项策略进行评比。周三晚21：00左右（节假日顺延）更新综合排名。</p>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">2、评分方法</div>
          <p>主办方根据产品参赛期间的净收益率，以及年化夏普比率、最大回撤等风险调整指标综合评价产品的表现，同时主办方专家评审结合产品规模、当赛季累计收益额、参赛时长、管理人在参赛期间的整体表现等情况进行综合打分。</p>
          <table cellspacing="0">
            <tr>
              <th></th>
              <th>维度</th>
              <th>权重</th>
            </tr>
            <tr>
              <th rowspan="4">综合评分</th>
              <td>参赛期间净收益率</td>
              <td>40%</td>
            </tr>
            <tr>
              <td>年化夏普比率</td>
              <td>20%</td>
            </tr>
            <tr>
              <td>参赛期间最大回撤</td>
              <td>20%</td>
            </tr>
            <tr>
              <td>专家评审</td>
              <td>20%</td>
            </tr>
          </table>
          <div :class="['title',{'titledhjr':fromdhjr}]">四、奖项设置及比赛奖励</div>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">1、奖项设置</div>
          <p>组委会根据参赛策略分设年度前三奖项。排名前位的机构有机会获得种子基金支持及商务合作机会。参赛策略报名后当赛季内不得更改。获奖产品当赛季须盈利为正。</p>
          <div :class="['ltitle',{'ltitledhjr':fromdhjr}]">2、比赛奖励</div>
          <p>
            获奖机构和产品有机会获得如下奖励：</p>
          <p>（1）东航金控十亿种子基金跟投；</p>
          <p>（2）东航金控、东航期货白名单准入资格；</p>
          <p>（3）入选东航金融推广渠道精选产品名单；</p>
          <p>（4）媒体宣传推广及基金经理专访；</p>
          <p>（5）参加线下资金对接会；</p>
          <p>（6）受邀参加“蓝海密剑”颁奖典礼、年度策略闭门会议；</p>
          <p>（7）恒生子公司云纪网络全面系统服务（CBS），支持资产管理、风险控制等；</p>
          <p>（8）程序化产品有机会使用交易所机房托管服务，享受高速交易通道。
          </p>
          <div :class="['title',{'titledhjr':fromdhjr}]">五、风险免责说明</div>
          <p>1、本次比赛参赛机构自行交易，所有交易须遵守相关法律法规。参赛机构确如有舞弊行为或操纵市场等行为，立即取消参赛机构的参赛资格；由此产生的一切后果由参赛机构承担。</p>
          <p>
            2、本次大赛组委会将本着勤勉尽职的态度竭力保证大赛的顺利进行，但不对参赛产品的任何投资风险、投资损失承担任何责任，也不对因不可抗力的因素或非主办机构所能控制的情况所导致的任何风险、系统故障或由于网络问题导致的系统故障等原因对参赛选手收益率及排名产生的影响等承担任何责任。</p>
          <p>3、参赛产品管理人应就产品参赛事宜向产品持有人进行披露并获得同意，管理人因产品参赛事宜与产品持有人发生纠纷的与大赛主办方无关，所有纠纷及其产生的一切法律和经济责任均由产品管理人自行承担。</p>
          <p>4、本次比赛的最终解释权归大赛主办方所有，主办方有权根据实际情况对大赛规则进行修改或调整，并通过相关途径进行公告。

          </p>
        </div>
        <div :class="['line',{'linedhjr':fromdhjr}]"><img v-if="!fromdhjr" src="../../assets/line.png"/></div>
        <div :class="['agree',{'agreedhjr':fromdhjr}]" @click="readagree">已阅读并同意</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props:[
      "tab",
      "fromdhjr"
    ],
    data() {
      return {
        activeTab: this.tab
      }
    },
    methods: {
      readagree() {
        this.$emit("readagree")
      }
    }
  }
</script>
<style scoped>
  .promiserules {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .7);
  }

  .contain {
    margin: 0 auto;
    width: 86vw;
    background: url("../../assets/rulesbg.png") #0e0d31 no-repeat;
    background-size: contain;
    position: absolute;
    height: 119vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    position: absolute;

    box-sizing: border-box;
    padding: 5vw 0 5vw 5vw;
  }
.containdhjr {
  background-image: none;
  background-color: #fff;
}
  .promiserulestitle {

    display: inline-block;
    width: 35vw;
    text-align: center;
    color: #353c67;
    font-size: 4vw;
  }
.promiserulestitledhjr {
  color: #3f3f3f;
}
  .titleactive {
    color: #fff;
    text-shadow: 2px 2px 10px #36dbfe;
    font-weight: bold;
  }
  .titleactivedhjr {
    color: #fda635;
    font-weight: bold;
    text-shadow: none;

  }

  .titlecontent img {
    width: 1vw;
  }

  .info {
    margin-top: 6vw;
  }

  p {
    color: #fff;
    padding-bottom: 5vw;
    font-size: 3.5vw;
    line-height: 5vw;
  }
.dhjr p {
  color: #3f3f3f;
}
  .promiserulescontent {
    height: 75vw;
    padding-right: 5vw;
    overflow: auto;
    margin-right: 1vw;
  }

  /*滚动条整体样式*/
  .promiserulescontent::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .promiserulescontent::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #48d2ff;
    border-radius: 4px;
  }

  /*滚动条轨道*/
  .promiserulescontent::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: #171945;
    border-radius: 4px;
  }

  /*滚动条滑块*/
  .promiserulescontentdhjr::-webkit-scrollbar-thumb {
    background: #fda635;
  }

  /*滚动条轨道*/
  .promiserulescontentdhjr::-webkit-scrollbar-track {
    background: #efefef;
  }
  .line {
    margin: 3vw 5vw 1vw 0;
  }
.linedhjr {
  height: 5vw;
}
  .line img {
    width: 100%;
  }

  .agree {
    width: 76vw;
    text-align: center;
    color: #000;
    font-size: 4vw;
    background: #3dbbfd;
    border-radius: 2vw;
    height: 11vw;
    line-height: 11vw;
    margin-bottom: 5vw;
  }
.agreedhjr {
  color: #fff;
  background: #fda635;
}
  .rulestitle {
    text-align: center;
    color: #fff;
    font-weight: bold;
    font-size: 4vw;
  }
.rulestitledhjr {
  color: #3f3f3f;
}
  .title {
    font-weight: bolder;
    color: #fff;
    font-size: 3.5vw;
    line-height: 6vw;
  }
.titledhjr {
  color: #3f3f3f;
}
  .ltitle {
    color: #fff;
    font-size: 3.5vw;
    line-height: 5vw;
  }
  .ltitledhjr {
    color: #3f3f3f;
  }

  table {
    width: 100%;
    margin: 0 auto;
    color: #fff;
    font-size: 3.5vw;
    text-align: center;
  }
  table {
    margin: 3vw 0 7vw 0;
    border-left: solid 1px #fff;
    border-bottom: solid 1px #fff;
  }
  td,th {
    line-height: 8vw;
    border-top: solid 1px #fff;
    border-right: solid 1px #fff;
  }
  .dhjr table {
    color: #3f3f3f;
  }
  .dhjr table {
    border-left: solid 1px #3f3f3f;
    border-bottom: solid 1px #3f3f3f;
  }
  .dhjr td,.dhjr th {
    line-height: 8vw;
    border-top: solid 1px #3f3f3f;
    border-right: solid 1px #3f3f3f;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/promiserules.vue